import Button from "../Components/Button";

export default function HomePage(){
    return (
        <div className="home-container">
            <section className="hero">
                <div className= "hero-background"></div>
                <div className="hero-text">
                    <h1>Integrated Railway Siding Management Solutions</h1>
                    <br></br>
                    <br></br>
                    <h4>InfraWorks Turnkey Projects is a leading South 
                        African professional services firm specializing 
                        in railway infrastructure. We offer comprehensive 
                        solutions tailored to meet your specific needs.
                    </h4>
                </div>
                <br></br>
                <br></br>
                <Button btnUrl="/about" btnName= "Learn More"/>
            </section>
            <section className="business-cycle">
                
            </section>
            {/* <section className="about-us">
                <div className="content">
                    <h2> ABOUT US</h2>
                    <p>InfraWorks Turnkey Projects is a South African-based 
                        professional services firm providing a wide variety 
                        of services such as advice, solutions and technical 
                        expertise in railway engineering, procurement, project 
                        management, construction and maintenance management services, 
                        tailored to meet each client’s specific needs with a focus on 
                        railway siding management.
                    </p>
                </div>
            </section> */}
        </div>
    );
}
